import { SellTagModelType } from '@teinor/erp/types/company/order/sell/sellTag'
import ModalCESellTag from './ModalCESellTag'
import ModalDeleteSellTag from './ModalDeleteSellTag'
import { useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import { useAddDoubleTableGreenRowRender } from '../../../../../../../baseComponents/DoubleTable/functions'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderColor, EditRow, DeleteRow, CustomRenderString } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import useSellTagTypesDict from '../../../../../../../utils/hooks/sells/useSellTagTypesDict'

interface SellTagsProps extends ComponentWithPermissions { }

const SellTags: React.FC<SellTagsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('sellTags', 'Etiquetas de ventas'),
        newText: t('newTag', 'Nueva etiqueta'),
    }
    return (
        <BaseScreenTable TableComponent={TableSellTags} CreateModalComponent={ModalCESellTag} EditModalComponent={ModalCESellTag} DeleteModalComponent={ModalDeleteSellTag} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableSellTagsProps extends TableComponentProps { }

const TableSellTags: React.FC<TableSellTagsProps> = ({ setTableInstance, setOpened, userPermissions }) => {
    const { t } = useTwinTranslation()
    const { id } = useParams()
    const tagTypesDict  = useSellTagTypesDict()
    const { rowRenderer } = useAddDoubleTableGreenRowRender(id || '')
    const columns: ColumnTableSchema<SellTagModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Name') }
            }
        },
        {
            id: 'color',
            dataKey: 'color',
            label: t('color', 'Color'),
            customRender: (parameterValue) => <CustomRenderColor value={parameterValue} />
        },
        {
            id: 'type',
            dataKey: 'type',
            label: t('tagType', 'Tipo de etiqueta'),
            customRender: (parameterValue) => <CustomRenderString value={tagTypesDict?.[parameterValue]?.name} />
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]

    return (
        <TwinTable name='SellTags' columns={columns} getDataFrom='/api/app/order/sell/sellTag/getAllSellTags' setTableInstance={setTableInstance} rowRenderer={rowRenderer} hideLoadFiltersButton={true} onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} />
    )
}



export default SellTags